import React, { useEffect, useState } from 'react'
// style
import {
  Grid,
  TextField,
  FormHelperText,
  MenuItem,
  Card,
  CardContent
} from '@material-ui/core'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'

import { Controller } from 'react-hook-form'
import classes from './../../pages/createOrder/index.module.scss'
import JalaliUtils from '@date-io/jalaali'
import { numberWithCommas } from './../../utils/helpers'
import { useCutoffHandler } from '../../utils/hook/useGetCutoffList'
import { convertDatePersianToEnglish } from '../../utils/helpers'
import { isWeekendDay } from '../../utils/Date/dayMethods'
import handleError from '../../utils/handleError'
import RonadIcons from '../iconComponent'
import moment from 'moment'

import env from 'client-sdk/src/enviroments/enviroment'
import fillmentTypes from 'client-sdk/src/orders/getFulfillmentTypes'
import shippingDefinitions from 'client-sdk/src/orders/shippingDefinitions'
import getPartnerCenters from 'client-sdk/src/orders/getPartnerCenters'

function OrderInputs(props: any) {
  moment.locale('en')
  const date = new Date()
  const formattedDate = moment(date).format('YYYY-MM-DD')

  const {
    isFulfillmentService,
    deliveryLocationType,
    setOrderPaymentType,
    setDeliveryServiceId,
    setDeliveryTime,
    setOrderValue,
    orderValue,
    editMode,
    form
  } = props

  const { errors, setValue, getValues, control, watch } = form
  const values = getValues()
  const [stateFillmentTypes, setStateFillmentTypes] = useState<any>([])
  const [shippingdefinitions, setShippingdefinitions] = useState<any>([])
  const [curierDTOList, setCurierDTOList] = useState<any>([])
  const [dateInDatePiker, setDateInDatePiker] = useState<any>('')
  const [centerList, setCenterList] = useState<object[]>([])

  const fulfillmentTypeId = watch('fulfillmentTypeId')
  const courierId = watch('courierId')
  const deliveryDate = watch('deliveryDate')
  const cutoffId = watch('cutoffId')
  const centerId = watch('centerId')

  const formattedDateSelected = moment(deliveryDate).format('YYYY-MM-DD')
  const dateSelected = convertDatePersianToEnglish(formattedDateSelected)

  const { listCutoff } = useCutoffHandler({
    courierId,
    dateSelected,
    fulfillmentTypeId,
    setDateInDatePiker,
    setValue,
    editMode: editMode
  })

  useEffect(() => {
    setValue('origin', env.destinationId)
  }, [])

  useEffect(() => {
    if (listCutoff.length > 0) {
      const rse = listCutoff.find((item: any) => item.id === cutoffId)
      setDeliveryTime(rse?.value)
      if (!rse) setValue('cutoffId', '')
    }
  }, [listCutoff, cutoffId])

  useEffect(() => {
    if (isFulfillmentService || deliveryLocationType) {
      setValue('customerProvince', 'تهران')
      setValue('customerCity', 'تهران')
    } else {
      setValue('customerProvince', '')
      setValue('customerCity', '')
    }
  }, [isFulfillmentService, deliveryLocationType])

  useEffect(() => {
    if (values.deliveryDate && !editMode) {
      setValue('deliveryTime', '')
    }
  }, [values.deliveryDate])

  useEffect(() => {
    setDateInDatePiker(formattedDate)
    editMode || setValue('deliveryDate', formattedDate)

    const fetchFillmentTypes = async () => {
      const isFromCenter = true
      try {
        const { res, ok } = await fillmentTypes('order', isFromCenter)
        if (ok) {
          setStateFillmentTypes(res)
        }
      } catch (error) {
        handleError(error)
      }
    }
    fetchFillmentTypes()
  }, [])

  useEffect(() => {
    if (stateFillmentTypes.length > 0) {
      const fetchShippingDefinitions = async () => {
        try {
          const { res, ok } = await shippingDefinitions(fulfillmentTypeId)
          if (ok) {
            setShippingdefinitions(res.shippingDefinitionList)
          }
        } catch (error) {
          handleError(error)
        }
      }
      fetchShippingDefinitions()
    }
  }, [stateFillmentTypes, fulfillmentTypeId])

  useEffect(() => {
    if (shippingdefinitions.length === 1) {
      const getCourierList = () => {
        const ress = shippingdefinitions.flatMap(
          (item: any) => item.deliveryServiceDTO
        )
        return ress[0]
      }
      const courierList = getCourierList()
      setDeliveryServiceId(courierList.id)
      setCurierDTOList(courierList?.courierDTOList)
    }
  }, [shippingdefinitions])

  useEffect(() => {
    const handlerFetchCenterList = async () => {
      try {
        const response = await getPartnerCenters()
        if (response.ok) {
          setCenterList(response.response)
        }
      } catch (error) {
        console.error('خطا در دریافت اطلاعات:', error)
      }
    }
    handlerFetchCenterList()
  }, [])

  useEffect(() => {
    if (curierDTOList?.length > 0) {
      curierDTOList.map((item: any) => {
        setOrderPaymentType(item.orderPaymentTypeDTO.name)
      })
    }
  }, [curierDTOList])

  return (
    <Card className={classes.card}>
      <CardContent style={{ padding: '12px !important' }}>
        <Grid container spacing={4}>
          <Grid container item spacing={2}>
            <Grid item sm={4}>
              <Controller
                name='trackingCode'
                label='کد پیگیری'
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Za-z\d\-_]+$/,
                  minLength: 3
                }}
                as={
                  <TextField
                    type='search'
                    variant='outlined'
                    fullWidth
                    id='trackingCode'
                    name='trackingCode'
                    error={!!errors.trackingCode && !!errors.trackingCode}
                  />
                }
              />
              <FormHelperText error focused>
                {errors?.trackingCode?.type === 'required' &&
                  'کدپیگیری الزامی میباشد'}
              </FormHelperText>
              <FormHelperText error focused>
                {errors?.trackingCode?.type === 'minLength' &&
                  'کد پیگیری حداقل 3 کاراکتر می باشد'}
              </FormHelperText>
            </Grid>
            <Grid item sm={4}>
              <Controller
                control={control}
                name='fulfillmentTypeId'
                label='* نوع پردازش '
                rules={{
                  required: true
                }}
                as={
                  <TextField
                    type='search'
                    variant='outlined'
                    select
                    fullWidth
                    InputLabelProps={{
                      shrink: true
                    }}
                    error={errors.fulfillmentTypeId && true}
                  >
                    {stateFillmentTypes.map((item: any, index: number) => {
                      return (
                        <MenuItem key={index} value={item.id}>
                          {item.name}
                        </MenuItem>
                      )
                    })}
                  </TextField>
                }
              />
              <FormHelperText error focused>
                {errors?.fulfillmentTypeId && 'نوع سفارش الزامی میباشد'}
              </FormHelperText>
            </Grid>

            <Grid item sm={4}>
              <Controller
                control={control}
                name='courierId'
                label='* ناوگان حمل'
                rules={{
                  required: true
                }}
                as={
                  <TextField
                    type='search'
                    variant='outlined'
                    select
                    InputLabelProps={{
                      shrink: true
                    }}
                    fullWidth
                    error={errors.courierId && true}
                  >
                    {curierDTOList?.map((item: any) => (
                      <MenuItem key={item.id} id={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </TextField>
                }
              />
              <FormHelperText error focused>
                {errors?.courierId && 'ناوگان حمل الزامی میباشد'}
              </FormHelperText>
            </Grid>
          </Grid>

          <Grid container item spacing={2}>
            <Grid item sm={3}>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale='fa'>
                <Controller
                  rules={{ required: true }}
                  name='deliveryDate'
                  control={control}
                  as={
                    <DatePicker
                      inputVariant='outlined'
                      name='deliveryDate'
                      label='* تاریخ تحویل به مشتری'
                      format='jYYYY/jMM/jDD'
                      minDate={dateInDatePiker}
                      fullWidth
                      disablePast
                      autoOk
                      okLabel='تأیید'
                      cancelLabel='لغو'
                      defaultValue={null}
                      disabled={fulfillmentTypeId == ''}
                      shouldDisableDate={(d: any) => isWeekendDay(d?._d)}
                      value={dateInDatePiker}
                      error={errors.hasOwnProperty('deliveryDate')}
                      helperText={
                        errors.deliveryDate && errors.deliveryDate.message
                      }
                    />
                  }
                />
                <FormHelperText error focused>
                  {errors.deliveryDate && 'تاریخ تحویل سفارش الزامی میباشد'}
                </FormHelperText>
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item sm={3}>
              <Controller
                rules={{ required: true }}
                control={control}
                name='cutoffId'
                label='* بازه تحویل به مشتری'
                as={
                  <TextField
                    variant='outlined'
                    select
                    fullWidth
                    label='* بازه تحویل سفارش'
                    disabled={courierId === null || courierId === ''}
                    error={!!errors.cutoffId}
                    InputLabelProps={{
                      shrink: cutoffId
                    }}
                  >
                    {listCutoff.map((item: any) => (
                      <MenuItem
                        disabled={!item.disableCutoff}
                        key={item.id}
                        value={item.id}
                        id={item.id}
                      >
                        {item.label}
                      </MenuItem>
                    ))}
                  </TextField>
                }
              />
              <FormHelperText error focused>
                {errors?.cutoffId && ' بازه تحویل به مشتری الزامی میباشد'}
              </FormHelperText>
            </Grid>
            <Grid item sm={3}>
              <Controller
                name='centerId'
                control={control}
                rules={{ required: true }}
                as={
                  <TextField
                    select
                    fullWidth
                    variant='outlined'
                    label='* محل تحویل سفارش'
                    error={!!errors.centerId}
                    InputLabelProps={{
                      shrink: Boolean(centerId)
                    }}
                  >
                    {centerList.map((item: any) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </TextField>
                }
              />
              <FormHelperText error focused>
                {errors?.centerId && ' محل تحویل سفارش الزامی میباشد'}
              </FormHelperText>
            </Grid>
            <Grid item sm={3}>
              <TextField
                type='search'
                variant='outlined'
                fullWidth
                disabled={values.fulfillmentTypeId == ''}
                id='orderValue'
                name='orderValue'
                label='ارزش سفارش (ریال)'
                value={numberWithCommas(orderValue)}
                error={!!errors.orderValue && !!errors.orderValue}
                InputLabelProps={{
                  shrink: numberWithCommas(orderValue)
                }}
                onChange={(e) =>
                  setOrderValue(e.target.value.replace(/,/g, ''))
                }
                InputProps={{
                  endAdornment: (
                    <RonadIcons
                      name='information'
                      className='text-primary'
                      size={0.8}
                      title='مقدار وارد شده به عنوان ارزش سفارش جهت بیمه ارسال اعمال میگردد'
                    />
                  )
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
export default OrderInputs
